import setWindowInteractionDisabled from './/setWindowInteractionDisabled';

let stackDepth = 0;

let DisableWindowInteractionUtil = {
  push() {
    stackDepth++;

    if (stackDepth === 1) {
      setWindowInteractionDisabled(true);
    }
  },

  pop() {
    if (stackDepth === 0) {
      throw new Error;
    }

    stackDepth--;

    if (stackDepth === 0) {
      setWindowInteractionDisabled(false);
    }
  }
};

export default DisableWindowInteractionUtil;
